import type { Action, ThunkAction } from '@reduxjs/toolkit';
import type { Dolan } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';
import type { EditorRootState } from '../../../editor/types';
import { editCurrentDescriptorProperty } from '../../../editor/actions';
import { selectCurrentDescriptor } from '../../../editor/selectors';

/**
 * Thunk action that allows convenient editing of the DOLAN using the current DOLAN
 * as a basis. Can be used together with Immer to write "mutative" logic.
 *
 * If you need to perform asynchronous logic for mutating the DOLAN, use `editCurrentDolanAsync` instead.
 */
export default function editCurrentDolan(
  edit: (currentDescriptor: Dolan) => Dolan,
): ThunkAction<Dolan, EditorRootState<Dolan>, unknown, Action<string>> {
  return (dispatch, getState) => {
    const dolan = selectCurrentDescriptor(getState());
    if (!dolan) {
      throw new Error('Cannot edit the current DOLAN before initialization');
    }
    const newDescriptor = edit(dolan);
    dispatch(editCurrentDescriptorProperty([], newDescriptor));
    return newDescriptor;
  };
}
